'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepTitle = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _setDisplayName = require('recompose/setDisplayName');

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _withStepper = require('./with-stepper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * A component that display the title of the active page.
 *
 * ### Usage
 * ```
 * <StepTitle />
 * ```
 */
var StepTitle = exports.StepTitle = (0, _compose2.default)(_withStepper.withStepper, (0, _setDisplayName2.default)('StepTitle'))(function (_ref) {
  var pages = _ref.pages,
      currentPage = _ref.currentPage,
      style = _ref.style;
  return React.createElement("span", { style: style }, pages[currentPage].title);
});
//# sourceMappingURL=step-title.js.map



//////////////////
// WEBPACK FOOTER
// ./dist/src/step-title.js
// module id = 841
// module chunks = 0